/*
 * @Description: 支持自定义端点样式的线条（无端点/三角/圆点）
 */
import { fabric } from 'fabric';

fabric.LineWithEndpoint = fabric.util.createClass(fabric.Line, {
  type: 'lineWithEndpoint',
  superType: 'drawing',
  
  initialize(points, options) {
    if (!points) {
      const { x1, x2, y1, y2 } = options;
      points = [x1, y1, x2, y2];
    }
    options = options || {};
    // 默认端点样式
    options.lineEndpoint = options.lineEndpoint || 'none';
    // 禁用对象缓存，避免端点被裁切
    options.objectCaching = false;
    this.callSuper('initialize', points, options);
  },

  _render(ctx) {
    // 先绘制线条本身
    this.callSuper('_render', ctx);
    
    // 如果端点为 none，不绘制端点
    if (this.lineEndpoint === 'none') {
      return;
    }

    ctx.save();

    const xDiff = this.x2 - this.x1;
    const yDiff = this.y2 - this.y1;
    const angle = Math.atan2(yDiff, xDiff);
    
    // 移动到线条终点（相对于对象中心）
    ctx.translate(xDiff / 2, yDiff / 2);
    ctx.rotate(angle);

    ctx.fillStyle = this.fill || this.stroke;
    ctx.strokeStyle = this.stroke;

    // 根据端点类型绘制不同形状
    if (this.lineEndpoint === 'triangle') {
      this._renderTriangleEndpoint(ctx);
    } else if (this.lineEndpoint === 'dot') {
      this._renderDotEndpoint(ctx);
    }

    ctx.restore();
  },

  /**
   * 绘制三角形端点，尺寸与 strokeWidth 成比例
   */
  _renderTriangleEndpoint(ctx) {
    const size = Math.max(this.strokeWidth * 2.5, 8);
    ctx.beginPath();
    ctx.moveTo(size * 0.4, 0);
    ctx.lineTo(-size * 0.6, size * 0.5);
    ctx.lineTo(-size * 0.6, -size * 0.5);
    ctx.closePath();
    ctx.fill();
  },

  /**
   * 绘制圆点端点，半径与 strokeWidth 成比例
   */
  _renderDotEndpoint(ctx) {
    const radius = Math.max(this.strokeWidth * 1.5, 4);
    ctx.beginPath();
    ctx.arc(0, 0, radius, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fill();
  },
});

fabric.LineWithEndpoint.fromObject = (options, callback) => {
  const { x1, x2, y1, y2 } = options;
  return callback(new fabric.LineWithEndpoint([x1, y1, x2, y2], options));
};

export default fabric.LineWithEndpoint;
